import FlycasterAvatar from '@components/FlycasterAvatar';
import CloseOutlined from '@icons/CloseOutlined';
import { Box, IconButton, Tab, Tabs, Typography } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import Groups from './Groups';
import LoginHistory from './LoginHistory';
import Projects from './Projects';

const UserDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userEmail } = useParams<{ userEmail: string }>();
  const onTabChanged = useCallback(
    (_: React.SyntheticEvent, newValue: 'projects' | 'groups' | 'loginhistory') => {
      navigate(`/admin/users/${userEmail}/${newValue}`);
    },
    [navigate, userEmail]
  );
  // extract activeTab from path param
  const pathParts = location.pathname.split('/');
  const pathPart = pathParts[4];
  const activeTab = (pathPart as 'projects' | 'groups' | 'loginhistory') || 'projects';

  useEffect(() => {
    // if no tab is selected, default to 'projects'
    if (!pathPart) {
      navigate(`/admin/users/${userEmail}/projects`, { replace: true });
    }
  }, [navigate, userEmail, pathPart]);

  const onClose = useCallback(() => {
    navigate('..');
  }, [navigate]);

  if (!userEmail) {
    return null;
  }
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1, height: '100%', minHeight: 0 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end'
        }}
      >
        <IconButton onClick={onClose}>
          <CloseOutlined />
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, flex: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
          <FlycasterAvatar disablePopup user={userEmail} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, justifyContent: 'flex-start' }}>
            <Typography variant="h7">{userEmail}</Typography>
            {/* <Typography variant="body1">User Email</Typography> */}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column', flex: 1 }}>
          <Tabs value={activeTab} onChange={onTabChanged}>
            <Tab value={'projects'} label="Projects" />
            <Tab value={'groups'} label="Groups" />
            <Tab value={'loginhistory'} label="Login History" />
          </Tabs>
          <Routes>
            <Route path="projects" element={<Projects userEmail={userEmail} />} />
            <Route path="groups" element={<Groups />} />
            <Route path="loginhistory" element={<LoginHistory />} />
          </Routes>
        </Box>
      </Box>
    </Box>
  );
};
export default UserDetails;
